import Swiper, { Navigation, Lazy } from "swiper";

class TimelineSlider {
  wrapper = null;

  constructor(el) {
    this.wrapper = $(el);

    if (this.wrapper.length) {
      this.init();
    }
  }

  init() {
    const timelineCount = this.wrapper.find(".timeline__slider .swiper-wrapper")[0].children.length;
    const enoughTimeline = timelineCount >= 5;

    // Adjust navigation visibility (toggle based on enoughPartners)
    const sliderNav = $(".timeline__slider-controls");
    if (sliderNav.length) {
      if (enoughTimeline) {
        sliderNav.removeClass("hidden");
      } else {
        sliderNav.addClass("hidden");
      }
    }

    new Swiper(this.wrapper.find(".timeline__slider")[0], {
      modules: [Lazy, Navigation],
      spaceBetween: 0,
      slidesPerView: 5,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 5,
      },
      navigation: enoughTimeline ? {
        prevEl: this.wrapper.find(".swiper-button-prev")[0],
        nextEl: this.wrapper.find(".swiper-button-next")[0],
      } : false,
      breakpoints: {
        1200: {
          slidesPerView: 4,
          slidesPerGroup: 3,
        },
        1000: {
          slidesPerView: 3,
          slidesPerGroup: 2,
        },
        900: {
          slidesPerView: 2,
          slidesPerGroup: 1,
        },
        0: {
          slidesPerView: 1,
          slidesPerGroup: 1,
        }
      },
    });
  }

};

export default TimelineSlider;
